import { apiInstance } from "@/api/instance";

export default async function () {
  return apiInstance.delete("/logout");
}
